module.exports = __webpack_public_path__ + "media/print/flashcard-styles_text-only-dbaf0d7e.png";